module.exports = "/assets/f5348f6d2825ccfd3498abe04852c0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IQ.png
// module id = 1483
// module chunks = 0